var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-mark"},[_c('help-circle-icon'),_c('div',{staticClass:"question-text",domProps:{"innerHTML":_vm._s(_vm.renderMarkdown(_vm.text))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }